<template>
<div class="fusion-footer">
    <footer role="contentinfo" class="fusion-footer-widget-area fusion-widget-area">
      <div class="fusion-row">
        <div class="fusion-columns fusion-columns-5 fusion-widget-area">
          <div class="fusion-column col-lg-2 col-md-2 col-sm-2">
            <section id="recent_works-widget-2" class="fusion-footer-widget-column widget recent_works">
              <h4 class="widget-title">{{ $t('footer.recentProducts') }}</h4>
              <div class="recent-works-items clearfix">
                <router-link
                  v-for="product in recentProducts"
                  :key="'recent-' + product.id"
                  :to="{ name: 'ProductDetail', params: { id: product.id } }"
                  :title="$productName(product)"
                >
                  <img
                    v-if="product.mainImageUrl"
                    :src="product.mainImageUrl"
                    :alt="$productName(product)"
                    width="66"
                    height="66"
                    loading="lazy"
                    decoding="async"
                    @error="onRecentImageError($event)"
                  />
                  <span v-else class="recent-works-items__fallback">{{ $productName(product) }}</span>
                </router-link>
              </div>
              <div style="clear: both"></div>
            </section>
            <section id="text-2" class="fusion-footer-widget-column widget widget_text">
              <div class="textwidget"></div>
              <div style="clear: both"></div>
            </section>
          </div>

          <div class="fusion-column col-lg-2 col-md-2 col-sm-2">
            <section id="text-3" class="fusion-footer-widget-column widget widget_text">
              <h4 class="widget-title">{{ $t('footer.inquiry') }}</h4>
              <div class="textwidget">
                <div role="form" class="wpcf7" dir="ltr">
                  <ContactInquiryForm variant="footer" />
                </div>
              </div>
              <div style="clear: both"></div>
            </section>
          </div>

          <div class="fusion-column col-lg-2 col-md-2 col-sm-2">
            <section id="nav_menu-3" class="fusion-footer-widget-column widget widget_nav_menu">
              <h4 class="widget-title">{{ $t('footer.categories') }}</h4>
              <div class="menu-sidebar-menu-container">
                <ul id="menu-sidebar-menu" class="menu">
                  <li
                    v-for="cat in footerCategories"
                    :key="'footer-cat-' + cat.id"
                    class="menu-item menu-item-type-post_type menu-item-object-page"
                  >
                    <router-link :to="categoryProductLink(cat.slug)">
                      {{ $categoryName(cat) }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div style="clear: both"></div>
            </section>
          </div>

          <div class="fusion-column col-lg-2 col-md-2 col-sm-2">
            <section id="contact_info-widget-2" class="fusion-footer-widget-column widget contact_info">
              <h4 class="widget-title">{{ $t('footer.contactInfo') }}</h4>
              <div class="contact-info-container">
                <p class="address">{{ $t('contact.address') }}</p>
                <p class="phone">{{ $t('footer.phone') }}: +86 18273950322</p>
                <p class="whatsapp">
                  {{ $t('footer.whatsapp') }}:
                  <a :href="whatsappUrl" target="_blank" rel="noopener noreferrer"
                    >+86 18273950322</a
                  >
                </p>
                <p class="email">
                  {{ $t('footer.email') }}: <a href="mailto:info@borisbags.com">info@borisbags.com</a>
                </p>
                <p class="web">
                  {{ $t('footer.web') }}:
                  <a href="#">www.borisbags.com</a>
                </p>
              </div>
              <div style="clear: both"></div>
            </section>
          </div>

          <div class="fusion-column fusion-column-last col-lg-2 col-md-2 col-sm-2">
            <section id="text-4" class="fusion-footer-widget-column widget widget_text">
              <h4 class="widget-title">{{ $t('footer.briefIntro') }}</h4>
              <div class="textwidget">
                {{ $t('footer.briefIntroText') }}
              </div>
              <div style="clear: both"></div>
            </section>
            <section id="text-5" class="fusion-footer-widget-column widget widget_text">
              <div class="textwidget"></div>
              <div style="clear: both"></div>
            </section>
          </div>

          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </footer>

    <div class="fusion-footer-copyright-area">
      <div class="fusion-row">
        <div class="fusion-copyright-content">
          {{ copyrightText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  categoryProductLink,
  fetchPublicCategories,
  mapStorefrontCategories
} from '@/api/categories'
import { WHATSAPP_URL } from '@/constants/contact'
import { fetchRecentProducts, mapStorefrontProduct } from '@/api/products'
import ContactInquiryForm from '@/components/ContactInquiryForm.vue'

export default {
  name: 'SiteFooter',
  components: { ContactInquiryForm },
  data() {
    return {
      footerCategories: [],
      recentProducts: [],
      whatsappUrl: WHATSAPP_URL
    }
  },
  created() {
    this.loadFooterCategories()
    this.loadRecentProducts()
  },
  computed: {
    copyrightText() {
      void this.currentLocale
      const endYear = new Date().getFullYear()
      return this.$t('footer.copyright').replace('{years}', `2010-${endYear}`)
    }
  },
  methods: {
    categoryProductLink,
    onRecentImageError(event) {
      event.target.style.display = 'none'
    },
    async loadRecentProducts() {
      try {
        const res = await fetchRecentProducts(6)
        const items = res.data?.items || []
        this.recentProducts = items.map(mapStorefrontProduct).slice(0, 6)
      } catch {
        this.recentProducts = []
      }
    },
    async loadFooterCategories() {
      try {
        const res = await fetchPublicCategories()
        this.footerCategories = mapStorefrontCategories(res.data?.items || [])
      } catch {
        this.footerCategories = []
      }
    }
  }
}
</script>
